module.exports = __webpack_public_path__ + "media/images/landing/alert-icon-a7da3d68bad50b9ed04dd20431cbc1af.svg";